export const openPdf = (pdfPath) => {
  console.log("Opening PDF:", pdfPath); 
  const path = pdfPath.startsWith('/') ? `/${encodeURIComponent(pdfPath.substring(1))}` : encodeURIComponent(pdfPath);
  window.open(`/view-pdf/${path}`, '_blank');
};
